export const cleanPertinentCategory = Object.freeze({
    label: 'New Pertinent Category',
});
//# sourceMappingURL=consts.js.map